const getBaseUrl: () => string | undefined = () => {
  const azoomeApiUrl = process.env.REACT_APP_AZOOMEE_API
  const dvmApiUrl = process.env.REACT_APP_DVMKIDS_API
  const hostname = document.location.hostname;

  if (process.env.NODE_ENV === 'development') {
    return dvmApiUrl;
  }

  if (hostname.includes('azoomee')) {
    return azoomeApiUrl;
  }

  if (hostname.includes('dvmkids') || hostname.includes('davinci')) {
    return dvmApiUrl;
  }
};

export default getBaseUrl